import {localCommand} from "../utils/api";

export const LESSON_COMPLETE = 'LESSON_COMPLETE';
export const LESSON_COMPLETE_SUCCESS = 'LESSON_COMPLETE_SUCCESS';
export const LESSON_COMPLETE_FAILED = 'LESSON_COMPLETE_FAILED';
export const completeLesson = localCommand('v1/lesson/CompleteLesson', LESSON_COMPLETE, LESSON_COMPLETE_SUCCESS, LESSON_COMPLETE_FAILED);